import React from 'react'

const OtgStatsSection = () => {
  return (
  <div className="py-5" style={{ backgroundColor: '#f8faff' }}>
      <div className="container">
        <div className="row text-center">
          <div className="col-md-3 mb-4">
            <h1 className="fw-bold  otgh1" >98%</h1>
            <p className="text-secondary">Placement Rate</p>
          </div>
          <div className="col-md-3 mb-4">
            <h1 className="fw-bold   otgh1" >15K+</h1>
            <p className="text-secondary" >Students Trained</p>
          </div>
          <div className="col-md-3 mb-4 ">
            <h1 className="fw-bold  otgh1" >50+</h1>
            <p className="text-secondary" >Partner Companies</p>
          </div>
          <div className="col-md-3 mb-4">
            <h1 className="fw-bold  otgh1" >₹4.5L</h1>
            <p className="text-secondary">Average Package</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OtgStatsSection
